import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export function selectorIsSharedFileBusinessCardContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return (
    !!contextType && contextType === SharedFileRequestContextType.BusinessCard
  );
}
